import React, { InputHTMLAttributes } from "react";
import styled from "styled-components";
import { MdSearch } from "react-icons/md";
import { Divider } from "@material-ui/core";

const Input = styled.input`
  width: 92%;
  height: 22px;
  border-radius: 5px;
  border: unset;
  padding-left: 5px;
  outline: unset;
`;

function Search({ ...rest }: ISearch) {
  return (
    <div
      style={{ overflow: "hidden", display: "flex", flexDirection: "column" }}
    >
      <div style={{ display: "flex" }}>
        <MdSearch
          style={{
            position: "relative",
            marginTop: "3px",
            marginLeft: "5px",
            fontSize: "20px",
            color: "#838282",
            opacity: 0.8,
          }}
        />
        <Input {...rest} />
      </div>
      <Divider style={{ marginTop: "8px" }} />
    </div>
  );
}

export interface ISearch extends InputHTMLAttributes<HTMLInputElement> {}

export default Search;
